export function getIndexByRoute(data, route) {
  if (!data) throw new Error('Data is missing');

  for (let index = 0; index < data.length; index++) {
    if (data[index].route === route) return index;
  }

  return null;
}
